import React, {useEffect, useState} from "react";
import {createPortal} from "react-dom";
import Masonry from "react-masonry-css";

const breakpoints = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1
};

const ImageGallery = ({images, label}) => {
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        if (!selectedImage) {
            return undefined;
        }

        const previousOverflow = document.body.style.overflow;
        const closeOnEscape = (event) => {
            if (event.key === "Escape") {
                setSelectedImage(null);
            }
        };

        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", closeOnEscape);

        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener("keydown", closeOnEscape);
        };
    }, [selectedImage]);

    return (
        <>
            <Masonry
                breakpointCols={breakpoints}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
            >
                {images.map((image, index) => (
                    <div className="mb-3" key={image.name}>
                        <button
                            aria-label={`Open ${label} ${index + 1}`}
                            className="gallery-image-button"
                            onClick={() => setSelectedImage(image)}
                            type="button"
                        >
                            <img
                                alt={`${label} ${index + 1}`}
                                className="img-fluid card-img-top"
                                decoding="async"
                                loading={index < 8 ? "eager" : "lazy"}
                                src={image.thumbnail}
                            />
                        </button>
                    </div>
                ))}
            </Masonry>

            {selectedImage && createPortal(
                <div
                    aria-label={`${label} preview`}
                    aria-modal="true"
                    className="lightbox show"
                    onClick={() => setSelectedImage(null)}
                    role="dialog"
                >
                    <button
                        aria-label="Close image"
                        className="lightbox-close"
                        onClick={() => setSelectedImage(null)}
                        type="button"
                    >
                        ×
                    </button>
                    <img
                        alt={`${label} full size`}
                        className="show_image"
                        decoding="async"
                        src={selectedImage.full}
                    />
                </div>,
                document.body
            )}
        </>
    );
};

export default ImageGallery;
